import React from 'react'

import { Button, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function Footer({
  isSignup,
  canSubmit,
  onSwitchMode,
  onSwitchToPassword,
}) {
  const t = useTranslation()

  return (
    <div className={classnames(
      'ai-sign-in-modal__footer',
      isSignup ? 'ai-sign-in-modal__footer--signup' : 'ai-sign-in-modal__footer--login'
    )}
    >
      <Button
        type="primary"
        size="medium"
        actionType="submit"
        disabled={!canSubmit}
        customClass="ai-sign-in-modal__submit"
      >
        {t('signIn.footer.submit')}
      </Button>

      {!isSignup && (
        <p className="ai-sign-in-modal__password-switch cgt-body-base">
          <button
            type="button"
            className="ai-sign-in-modal__switch-link cgt-body-md-semibold cgt-link-secondary"
            onClick={onSwitchToPassword}
          >
            {t('signIn.password.link')}
          </button>
        </p>
      )}

      <p className="ai-sign-in-modal__switch cgt-body-base">
        {isSignup ? t('signIn.footer.haveAccount') : t('signIn.footer.noAccount')}
        {' '}
        <button
          type="button"
          className="ai-sign-in-modal__switch-link cgt-body-md-semibold cgt-link-primary-accented"
          onClick={onSwitchMode}
        >
          {isSignup ? t('signIn.footer.login') : t('signIn.footer.signup')}
        </button>
      </p>
    </div>
  )
}

Footer.propTypes = {
  isSignup: bool.isRequired,
  canSubmit: bool.isRequired,
  onSwitchMode: func.isRequired,
  onSwitchToPassword: func.isRequired,
}

export default Footer
